// extracted by mini-css-extract-plugin
var _1 = "HotkeyInfo-module__animateUploadProgressBarWidth--w9JIz";
var _2 = "HotkeyInfo-module__animatedBackground--YAWlv";
var _3 = "HotkeyInfo-module__hotkeyInfo--mytWs";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "hotkeyInfo" }
